import { render } from "./IssueArticlePrimaryImage.vue?vue&type=template&id=61b8498e"
import script from "./IssueArticlePrimaryImage.vue?vue&type=script&lang=js"
export * from "./IssueArticlePrimaryImage.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3963854441/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__